import InputButton, {InputButtonProps} from '../input-button';
import TextArea, {TextAreaProps} from '../text-area';
import Select, {SelectProps} from '../select';
import MultiSelect, {MultiSelectProps} from '../multi-select';
import DatePicker, {DatePickerProps} from '../date-picker';
import TimePicker, {TimePickerProps} from '../time-picker';
import AddressInput, {AddressInputProps} from '../address-input';
import Input, {InputProps} from '../input';
import {BaseInputProps} from '../..';
import {
  TranslationKeyProps,
  translatedProps,
} from 'shared/util/translated-props';
import getNestedKey from 'shared/util/get-nested-key';
import Switch, {SwitchProps} from '../switch';
import NumberInput, {NumberInputProps} from '../number-input';
import AudioRecorder, {AudioRecorderProps} from '../audio-recorder';
import AsyncSelect, {AsyncSelectProps} from '../async-select';
import getSentenceGender from 'shared/util/find-sentence-gender';
import AsyncMultiSelect, {AsyncMultiSelectProps} from '../async-multi-select';
import PriceInput, {PriceInputProps} from '../price-input';

const handleGetInput = (
  input: BaseInputProps,
  translationKey: TranslationKeyProps,
) => {
  const translationName = input
    .name!.split('.')
    .reduce((keys, key) => {
      if (!isNaN(+key)) return [];

      return [...keys, key];
    }, [] as string[])
    .join('.');

  if (!input.label)
    input.label = getNestedKey(
      typeof translationKey !== 'string'
        ? translationKey
        : translatedProps[translationKey as keyof typeof translatedProps],
      translationName,
    );

  const sentenceGender = getSentenceGender(input.label);

  if (!input.placeholder)
    input.placeholder = `Informe ${sentenceGender} ${input.label.toLocaleLowerCase()}`;

  switch (input.type) {
    case 'input-button':
      return <InputButton key={input.name} {...(input as InputButtonProps)} />;
    case 'text-area':
      return <TextArea key={input.name} {...(input as TextAreaProps)} />;
    case 'select':
      return <Select key={input.name} {...(input as SelectProps)} />;
    case 'multi-select':
      return <MultiSelect key={input.name} {...(input as MultiSelectProps)} />;
    case 'date-picker':
      return <DatePicker key={input.name} {...(input as DatePickerProps)} />;
    case 'time-picker':
      return <TimePicker key={input.name} {...(input as TimePickerProps)} />;
    case 'address-input':
      return (
        <AddressInput key={input.name} {...(input as AddressInputProps)} />
      );
    case 'switch':
      return <Switch key={input.name} {...(input as SwitchProps)} />;
    case 'async-select':
      return <AsyncSelect key={input.name} {...(input as AsyncSelectProps)} />;
    case 'number-input':
      return <NumberInput key={input.name} {...(input as NumberInputProps)} />;
    case 'audio-recorder':
      return (
        <AudioRecorder key={input.name} {...(input as AudioRecorderProps)} />
      );
    case 'async-multi-select':
      return (
        <AsyncMultiSelect
          key={input.name}
          {...(input as AsyncMultiSelectProps)}
        />
      );
    case 'price-input':
      return <PriceInput key={input.name} {...(input as PriceInputProps)} />;
    default:
      return <Input key={input.name} {...(input as InputProps)} />;
  }
};

export default handleGetInput;
